import moment from 'moment'
const replaceDotWithComma = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return parseFloat(value).toFixed(2).toString().replace('.', ',')
}
const replaceCommaWithDot = (value) => {
  if (!value) return ''
  return value.toString().replace(',', '.')
}
const filterDate = (date) => {
  if (!date) return null
  return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
}

const filterDateTime = (date) => {
  if (!date) return null
  return moment(date, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(date, 'DD.MM.YYYY  HH:mm:ss').format('DD.MM.YYYY  HH:mm:ss') : null
}

export { replaceDotWithComma, replaceCommaWithDot, filterDate, filterDateTime }
